import React, { useState, useEffect } from "react";
import { useParams } from "react-router";

import UserDetail from "./UserDetail";
import LoadingSpinner from "../../common/LoadingSpinner";
import { SonicLinkedPages } from "../../common/classes/SonicLinkedPages";

import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import { getPerson, getPersonData } from "../../redux/reducers/person";

import { getUserDetail } from "../../services/api/user/getUserDetail";

import { useGetTeams } from "../../utils/useTeam";
import { useGetProject } from "../../utils/useProject";
import { useGetEvents } from "../../utils/useEvent";
import { useGetTopics } from "../../utils/useTopics";

const UserDetailContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [userData, setUserData] = useState<{
    name: string;
    links: SonicLinkedPages;
  }>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const dispatch = useAppDispatch();

  const profiles = useAppSelector(getPersonData);

  useEffect(() => {
    const fetchLinks = async () => {
      if (!id) return;

      const res = await getUserDetail(id);

      if (res) {
        setUserData(res);
      }
      if (res.links.database_entry && res.links.database_entry.length > 0) {
        dispatch(getPerson({ id: res.links.database_entry }));
      }
    };

    // TODO Loading adjustments when using React Query
    fetchLinks().finally(() => setIsLoading(false));
  }, []);

  // userDataがない場合に別の処理をしようとすると、hookのエラーが出るので、必ず存在する状態でqueryを呼ぶ
  const FetchContainer: React.FC<{
    userData: { name: string; links: SonicLinkedPages };
  }> = ({ userData }) => {
    const {
      items: { teams },
      isLoading: teamLoading,
    } = useGetTeams({ id: userData ? userData.links.team : null });

    const {
      items: { projects },
      isLoading: projectLoading,
    } = useGetProject(
      { id: userData ? userData.links.project : null },
      userData.links.project?.length ? true : false
    );

    const {
      items: { events },
      isLoading: eventLoading,
    } = useGetEvents({ id: userData ? userData.links.event : null });

    const {
      topicsData: { items: topics },
      isLoading: topicsLoading,
    } = useGetTopics({ id: userData ? userData.links.topics : null });

    if (teamLoading || projectLoading || eventLoading || topicsLoading)
      return <LoadingSpinner space={5} />;

    return (
      <UserDetail
        username={userData.name}
        profiles={
          userData.links.database_entry &&
          userData.links.database_entry.length > 0
            ? profiles
            : undefined
        }
        teams={teams}
        projects={projects}
        events={events}
        topics={topics}
      />
    );
  };

  if (isLoading || !userData) {
    return <LoadingSpinner space={5} />;
  } else {
    return <FetchContainer userData={userData} />;
  }
};

export default UserDetailContainer;
